/**
 * Function to be used in Once context where the installation context is not
 * set automatically.
 *
 * @param {Object} event
 * @param {Object} data
 * @param {Object} installation
 */
export function trackForInstall(event, data, installation) {
  dpAnalytics
    .createAnalyticsService({
      send(name, event) {
        analytics.track(name, event, {
          integrations: {
            'Google Universal Analytics': {
              clientId:
                window.__APP__.analyticsContext.analyticsIntegration
                  ?.googleAnalyticsClientId,
            },
          },
        });
      },
      installationId: installation.ID,
      context: {
        ...window.__APP__.analyticsContext,
        installation: {
          ...window.__APP__.analyticsContext.installation,
          ...installation,
          alternateHostname: installation.hostname,
        },
      },
    })
    .track(event, data);
}
